import React from 'react';
import {Inc,Room,Talk} from './Inc';
import {Tools} from './Tools';

interface Props {
	room:Room,
	talk:Talk,
}

const TalkStart = (props:Props)=> {
    return (
		<div className="sysTalk">
			<span className="type">最低人数達成</span>
			<span className="detail">{props.room.Faces[Inc.numFaces].Name}が喜んで空中に署名をしました。</span>
			<span className="time">{Tools.toTime(props.talk.Date)}</span>
		</div>
	);
}

export default TalkStart;
